import React, { ReactNode, Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import IconChevronLeft from '../Icon/IconChevronLeft'

export interface Props {
  children?: ReactNode
  isOpen: boolean
  closeModal: () => void
}

const ModalGallery: React.FC<Props> = ({ children = undefined, isOpen, closeModal }) => (
  <Transition show={isOpen} as={Fragment}>
    <Dialog
      as="div"
      className="fixed left-0 top-0 z-modal h-full w-full overflow-y-auto bg-white"
      onClose={closeModal}
    >
      <Transition.Child
        as={Fragment}
        enter="ease-out duration-300"
        enterFrom="opacity-0 scale-95"
        enterTo="opacity-100 scale-100"
        leave="ease-in duration-200"
        leaveFrom="opacity-100 scale-100"
        leaveTo="opacity-0 scale-95"
      >
        <Dialog.Panel className="relative h-full w-full px-4 pb-4 pt-20 md:p-20">
          <div className="fixed left-0 top-0 z-10 h-16 w-full bg-white md:h-auto md:w-auto md:bg-transparent">
            <button
              onClick={closeModal}
              type="button"
              className="absolute left-4 top-4 flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 transition-colors duration-200 ease-in-out hover:bg-gray-200 md:left-6 md:top-6 md:h-10 md:w-10"
            >
              <IconChevronLeft size="20" />
            </button>
          </div>
          <div className="pb-4 md:pb-20">{children}</div>
        </Dialog.Panel>
      </Transition.Child>
    </Dialog>
  </Transition>
)

export default ModalGallery
